const categoryTable = [
  {
    value: 'category_name',
    name: '板块名称'
  },
  {
    value: 'category_type',
    name: '板块类型'
  },
  {
    value: 'sort_number',
    name: '板块排序'
  },
  {
    value: 'posts_number',
    name: '板块帖子数'
  },
  {
    value: 'create_time',
    name: '创建时间'
  },
  {
    value: 'is_hot_category',
    name: '热门',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    }
  },
  {
    value: 'activate_status',
    name: '状态',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '正常',
          value: true
        },
        {
          label: '禁用',
          value: false
        }
      ]
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '130px'
    }
  }
];
const postsOffTable = [
  {
    value: 'content',
    name: '帖子内容'
  },
  {
    value: 'post_user_name',
    name: '发帖人'
  },
  {
    value: 'post_time',
    name: '发帖时间'
  },
  {
    value: 'tip_off_count',
    name: '举报次数'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '154px'
    }
  }
];

const postsOffBackTable = [
  {
    value: 'content',
    name: '回帖内容'
  },
  {
    value: 'reply_user_name',
    name: '回帖人'
  },
  {
    value: 'reply_time',
    name: '回帖时间'
  },
  {
    value: 'tip_off_count',
    name: '举报次数'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '154px'
    }
  }
];

const CommunityContentTable = [
  {
    value: 'content',
    name: '内容',
    option: {
      width: '156px'
    }
  },
  {
    value: 'category_name',
    name: '所属板块'
  },
  {
    value: 'post_time',
    name: '发帖时间'
  },
  {
    value: 'post_user_name',
    name: '发帖人'
  },
  {
    value: 'reply_count',
    name: '回帖数'
  },
  {
    value: 'like_count',
    name: '点赞数'
  },
  {
    value: 'is_topping',
    name: '置顶',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    }
  },
  {
    value: 'is_essence',
    name: '精华',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    }
  },
  {
    value: 'is_official',
    name: '官方',
    headerSlot: {
      type: 'select',
      select: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ]
    }
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '130px'
    }
  }
];

const communityUserTable = [
  {
    value: 'community_nickname',
    name: '昵称'
  },
  {
    value: 'register_user_name',
    name: '用户名'
  },
  {
    value: 'register_user_phone',
    name: '手机号'
  },
  {
    value: 'create_time',
    name: '生成时间'
  },
  {
    value: 'post_number',
    name: '发帖数'
  },
  {
    value: 'reply_number',
    name: '回帖数'
  },
  {
    value: 'action',
    name: '操作',
    option: {
      width: '154px'
    }
  }
];
const appointmentTable = [
  {
    value: 'reserve_user_name',
    name: '预约人姓名'
  },
  {
    value: 'reserve_user_id_card_type_label',
    name: '证件类型'
  },
  {
    value: 'reserve_user_id_card_number',
    name: '证件号码'
  },
  {
    value: 'reserve_user_phone',
    name: '手机号码'
  },
  {
    value: 'reserve_time',
    name: '预约日期'
  },
  {
    value: 'register_user_name',
    name: '预约账号'
  },
  {
    value: 'create_time',
    name: '提交时间'
  }
];

export { categoryTable, postsOffTable, postsOffBackTable, CommunityContentTable, communityUserTable, appointmentTable };
